export default "__VITE_ASSET__e5f46034__"